module.exports = __webpack_public_path__ + "static/GreenSlate-c9e7f115b5caa162ee235b6ad301a4b4.jpg";